import { RootState } from '@modules/App/redux/store';
import { ChatMessage } from '@modules/HappinessModule/interfaces/ChatMessage';
import { AsyncData } from '@shared/interfaces/asyncData';

export const chatDataSelector = (state: RootState): AsyncData<ChatMessage[]> => state.happiness.chatPage.chatData;
